module.exports = __webpack_public_path__ + "static/media/security_secure_key.c53abe40.svg";